import { traverse } from "./traverse.qwik.mjs";
function isLocalizedField(value) {
  return value && typeof value === "object" && value["@type"] === "@builder.io/core:LocalizedValue";
}
function containsLocalizedValues(data) {
  if (!data || !Object.getOwnPropertyNames(data).length)
    return false;
  let hasLocalizedValues = false;
  traverse(data, (value) => {
    if (isLocalizedField(value)) {
      hasLocalizedValues = true;
      return;
    }
  });
  return hasLocalizedValues;
}
function extractLocalizedValues(data, locale) {
  if (!data || !Object.getOwnPropertyNames(data).length)
    return {};
  traverse(data, (value, update) => {
    if (isLocalizedField(value))
      update(value[locale] ?? void 0);
  });
  return data;
}
function resolveLocalizedValues(block, locale) {
  var _a, _b;
  if (((_a = block.component) == null ? void 0 : _a.options) && containsLocalizedValues((_b = block.component) == null ? void 0 : _b.options)) {
    if (!locale)
      console.warn("[Builder.io] In order to use localized fields in Builder, you must pass a locale prop to the BuilderComponent or to options object while fetching the content to resolve localized fields. Learn more: https://www.builder.io/c/docs/localization-inline#targeting-and-inline-localization");
    block.component.options = extractLocalizedValues(block.component.options, locale ?? "Default");
  }
  return block;
}
export {
  resolveLocalizedValues
};
